import { createContext, useState } from "react";
import dayjs from "dayjs";

export const AnaliseComparativaContext = createContext();

export const AnaliseComparativaProvider = ({ children }) => {
    const [grupos, setGrupos] = useState([]);
    const [selectedGrupos, setSelectedGrupos] = useState([]);
    const [startDate, setStartDate] = useState(dayjs().startOf("month").format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [comparisonData, setComparisonData] = useState(null);
    const [aiInsights, setAiInsights] = useState(null);
    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    return (
        <AnaliseComparativaContext.Provider value={{
            grupos, setGrupos,
            selectedGrupos, setSelectedGrupos,
            startDate, setStartDate,
            endDate, setEndDate,
            comparisonData, setComparisonData,
            aiInsights, setAiInsights,
            isAnalyzing, setIsAnalyzing,
            isLoading, setIsLoading,
        }}>
            {children}
        </AnaliseComparativaContext.Provider>
    );
};
